/**
 * Get a time-based greeting message
 * @returns "Good morning", "Good afternoon", or "Good evening"
 */
export function getTimeBasedGreeting(): string {
  const hour = new Date().getHours()

  if (hour >= 5 && hour < 12) {
    return 'Good morning'
  } else if (hour >= 12 && hour < 18) {
    return 'Good afternoon'
  } else {
    return 'Good evening'
  }
}

/**
 * Get a personalized greeting with user's full name
 * @param firstName - User's first name
 * @param lastName - User's last name (optional)
 * @returns Formatted greeting like "Good morning, John Doe"
 */
export function getPersonalizedGreeting(
  firstName: string,
  lastName?: string,
): string {
  const timeGreeting = getTimeBasedGreeting()
  const fullName = lastName ? `${firstName} ${lastName}` : firstName
  return `${timeGreeting}, ${fullName}`
}
